import apiEndPoints from '../utils/ctxUtil';
import { adalApiFetch } from '../adalConfig';

export function conversionRateListHasErrored(bool) {
  return {
    type: 'CONVERSION_RATE_LIST_HAS_ERRORED',
    hasErrored: bool,
  };
}

export function conversionRateListIsLoading(bool) {
  return {
    type: 'CONVERSION_RATE_LIST_IS_LOADING',
    isLoading: bool,
  };
}

export function conversionRateListDataSuccess(items) {
  return {
    type: 'CONVERSION_RATE_LIST_FETCH_DATA_SUCCESS',
    items,
  };
}

export function conversionRateAddHasErrored(bool, error) {
  return {
    type: 'CONVERSION_RATE_ADD_HAS_ERRORED',
    hasErrored: bool,
    errorMessage: error,
  };
}

export function conversionRateAddIsLoading(bool) {
  return {
    type: 'CONVERSION_RATE_ADD_IS_LOADING',
    isLoading: bool,
  };
}

export function conversionRateAddDataSuccess(bool) {
  return {
    type: 'CONVERSION_RATE_ADD_DATA_SUCCESS',
    isConversionRateAddSuccess: bool,
  };
}

export function eftCategoriesListHasErrored(bool) {
  return {
    type: 'EFT_CODE_LIST_HAS_ERRORED',
    hasErrored: bool,
  };
}

export function eftCategoriesListListIsLoading(bool) {
  return {
    type: 'EFT_CODE_LIST_IS_LOADING',
    isLoading: bool,
  };
}

export function eftCategoriesListDataSuccess(items) {
  return {
    type: 'EFT_CODE_LIST_FETCH_DATA_SUCCESS',
    items,
  };
}

export function deleteconversionRateHasErrored(bool, error) {
  return {
    type: 'CONVERSION_RATE_DELETE_ERRORED',
    hasErrored: bool,
    errorMessage: error,
  };
}

export function deleteconversionRateIsLoading(bool) {
  return {
    type: 'CONVERSION_RATE_DELETE_IS_LOADING',
    isLoading: bool,
  };
}

export function deleteconversionRateSuccess(bool) {
  return {
    type: 'CONVERSION_RATE_DELETE_SUCCESS',
    isSuccess: bool,
  };
}

export function setEndDateconversionRateHasErrored(bool, error) {
  return {
    type: 'CONVERSION_RATE_SET_END_DATE_ERRORED',
    hasErrored: bool,
    errorMessage: error,
  };
}

export function setEndDateconversionRateIsLoading(bool) {
  return {
    type: 'CONVERSION_RATE_SET_END_DATE_IS_LOADING',
    isLoading: bool,
  };
}

export function setEndDateconversionRateSuccess(bool) {
  return {
    type: 'CONVERSION_RATE_SET_END_DATE_SUCCESS',
    isSuccess: bool,
  };
}

export function resetErrorMessages() {
  return {
    type: 'RESET_ERROR_MESSAGE',
  };
}

export function getConversionRatesData() {
  const url = apiEndPoints.DOLLAR_CONVERSION_RATE_LIST;

  return (dispatch) => {
    dispatch(conversionRateListHasErrored(false, {}));
    dispatch(conversionRateListIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(conversionRateListIsLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((items) => dispatch(conversionRateListDataSuccess(items)))
      .catch((err) => {
        dispatch(conversionRateListHasErrored(true, err));
        dispatch(conversionRateListIsLoading(false));
      });
  };
}

export function addConversionRatesData(conversionRate) {
  const url = apiEndPoints.DOLLAR_CONVERSION_RATE_ADD;

  return (dispatch) => {
    dispatch(conversionRateAddIsLoading(true));
    dispatch(conversionRateAddHasErrored(false, ''));

    adalApiFetch(fetch, url, {
      method: 'POST', // or "PUT"
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify(conversionRate),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        dispatch(conversionRateAddIsLoading(false));

        if (!response.ok) {
          if (response.status == 400) {
            response.json().then(function (error) {
              dispatch(conversionRateAddHasErrored(true, error.message));
            });
          } else throw Error(response.statusText);
        }
        return response;
      })
      //.then((response) => response.json())
      .then(() => dispatch(conversionRateAddDataSuccess(true)))
      .then(() => dispatch(getConversionRatesData()))
      .catch((err) => {
        dispatch(conversionRateAddHasErrored(true, err.message));
        dispatch(conversionRateAddIsLoading(false));
      });
  };
}

export function removeConversionRatesData(rateId) {
  const url = apiEndPoints.DOLLAR_CONVERSION_RATE_DELETE.replace(
    'rateId',
    rateId,
  );

  return (dispatch) => {
    dispatch(deleteconversionRateIsLoading(true));
    dispatch(deleteconversionRateHasErrored(false, ''));

    adalApiFetch(fetch, url, {
      method: 'DELETE', // or "PUT"
      mode: 'cors',
      cache: 'no-cache',
      // body: JSON.stringify(conversionRate),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        dispatch(deleteconversionRateIsLoading(false));

        if (!response.ok) {
          if (response.status == 400) {
            response.json().then(function (error) {
              dispatch(deleteconversionRateHasErrored(true, error.message));
            });
          } else throw Error(response.statusText);
        }
        return response;
      })
      .then(() => dispatch(deleteconversionRateSuccess(true)))
      .then(() => dispatch(getConversionRatesData()))
      .catch((err) => {
        dispatch(deleteconversionRateHasErrored(true, err.message));
        dispatch(deleteconversionRateIsLoading(false));
      });
  };
}

export function setEndDateConversionRatesData(rateId, endDate) {
  const url = apiEndPoints.DOLLAR_CONVERSION_RATE_SET_END_DATE.replace(
    'rateId',
    rateId,
  );

  return (dispatch) => {
    dispatch(setEndDateconversionRateIsLoading(true));
    dispatch(setEndDateconversionRateHasErrored(false, ''));

    adalApiFetch(fetch, url, {
      method: 'PUT', // or "PUT"
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify({ Id: rateId, endDate: endDate }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        dispatch(setEndDateconversionRateIsLoading(false));

        if (!response.ok) {
          if (response.status == 400) {
            response.json().then(function (error) {
              dispatch(setEndDateconversionRateHasErrored(true, error.message));
            });
          } else throw Error(response.statusText);
        }
        return response;
      })
      //.then((response) => response.json())
      .then(() => dispatch(setEndDateconversionRateSuccess(true)))
      .then(() => dispatch(getConversionRatesData()))
      .catch((err) => {
        dispatch(setEndDateconversionRateHasErrored(true, err.message));
        dispatch(setEndDateconversionRateIsLoading(false));
      });
  };
}

export function getEftCategoriesData() {
  const url = apiEndPoints.EFT_CATEGORY_LIST;

  return (dispatch) => {
    dispatch(eftCategoriesListListIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(eftCategoriesListListIsLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((items) => dispatch(eftCategoriesListDataSuccess(items)))
      .catch(() => {
        dispatch(eftCategoriesListHasErrored(true));
        dispatch(eftCategoriesListListIsLoading(false));
      });
  };
}
